import { useState } from "react";
import "../../css/stickyMenu.css";
import { NavLink } from 'react-router-dom';
import {ga4Event} from '../util/ga4';

function StickyLeftButton({offerIndex = 0, stickyTheme}){
    const [expand, setExpand] = useState(true);

    const offerItems = [
        {
            'image' : '/assets/sticky_icon/Icon_T-CARE.png',
            'head' : 'Mau servis gratis?',
            'body' : 'T-CARE: Bebas biaya servis 7x + Extended Warranty',
            'url' : '/t-care',
            'buttonText' : 'T-CARE'
        },
        {
            'image' : '/assets/sticky_icon/Icon_T-OPT.png',
            'head' : 'Butuh suku cadang terjangkau?',
            'body' : 'Kenali T-OPT, sparepart murah dengan kualitas Toyota',
            'url' : '/products/t-opt',
            'buttonText' : 'T-OPT'
        },
        {
            'image' : '/assets/sticky_icon/Icon_Body_Paint.png',
            'head' : 'Mobil lecet atau penyok?',
            'body' : 'Percayakan ke Toyota Body & Paint: Perbaikan sempurna, kualitas asli Toyota!',
            'url' : '/services/body-paint',
            'buttonText' : 'Body & Paint'
        },
        {
            'image' : '/assets/sticky_icon/Icon_Toyota_Mobile_Service.png',
            'head' : 'Servis tanpa repot?',
            'body' : 'Gunakan Toyota Mobile Service: Teknisi datang ke lokasi Anda!',
            'url' : '/services/toyota-mobile-service',
            'buttonText' : 'Mobile Service'
        },
        {
            'image' : '/assets/sticky_icon/Icon_Hybrid_Health_Check.png',
            'head' : 'Cek baterai hybrid gratis?',
            'body' : 'Hybrid Health Check solusinya!',
            'url' : '/hybrid-health-check',
            'buttonText' : 'Hybrid Health Check'
        },
        {
            'image' : '/assets/sticky_icon/Icon_Tire_Solution.png',
            'head' : 'Ganti ban kualitas oke?',
            'body' : 'Manfaatkan Tire Solution, ban dengan variasi dan kualitas terbaik dari Toyota',
            'url' : '/products/tire-solution',
            'buttonText' : 'Tire Solution'
        },
        {
            'image' : '/assets/sticky_icon/Icon_Warranty.png',
            'head' : '',
            'body' : 'Tenang, mobilmu terjamin garansi Toyota!',
            'url' : '/warranty',
            'buttonText' : 'Warranty'
        },
        {
            'image' : '/assets/sticky_icon/Icon_TMO.png',
            'head' : 'Rawat Toyota-mu dengan produk asli!',
            'body' : 'TMO: Produk lubricants & chemical asli Toyota',
            'url' : '/products/tmo',
            'buttonText' : 'TMO'
        },
        {
            'image' : '/assets/sticky_icon/Icon_Express_Maintenance.png',
            'head' : 'Buru-buru tapi butuh servis?',
            'body' : 'Booking Express Maintenance: Servis cepat 30 menit',
            'url' : '/services/express-maintenance',
            'buttonText' : 'Express Maintenance'
        }
    ];

    useState(()=>{
        setTimeout(function(){
            setExpand(false);
        }, 3000);
    }, [])

    return <div id="stickyLeftButton" className={expand ? 'expand' : ''}>
        <span id="closeButton" onClick={()=> {
            setExpand(false);
            window.dataLayer.push({
                event: 'aftersales_sticky_close_click',
                menu_section: 'aftersales_sticky_left_menu',
                click_detail: '[CLOSE] ' + offerItems[offerIndex].buttonText,
            });
            // window.gtag('event', 'aftersales_sticky_close_click', {
            //     menu_section: 'aftersales_sticky_left_menu',
            //     click_detail: '[CLOSE] ' + offerItems[offerIndex].buttonText,
            // });
        }}>x</span>
        <img
            src={offerItems[offerIndex].image}
            className="d-block m-auto"
            onClick={()=> {
                setExpand(true);
                window.dataLayer.push({
                    event: 'aftersales_left_sticky_open_click',
                    menu_section: 'aftersales_sticky_left_menu',
                    click_detail: '[OPEN] ' + offerItems[offerIndex].buttonText,
                });
            }}
            height={35} />
        <div>
            <p className="text-center fw-bold mb-2">{offerItems[offerIndex].head}</p>
            <p className="text-center mb-3">{offerItems[offerIndex].body}</p>
            <NavLink
                role="button"
                to={{
                    pathname: offerItems[offerIndex].url
                }}
                className={`btn btn-sm btn-block w-100 ${stickyTheme}`}
                onClick={() => {
                    // window.gtag('event', 'menu_click', {
                    //     menu_section: 'aftersales_sticky_left_menu',
                    //     event_feature: 'sticky_menu_click',
                    //     click_detail: offerItems[offerIndex].buttonText,
                    // });
                    ga4Event('menu_click', {
                        menu_section: 'aftersales_sticky_left_menu',
                        event_feature: 'sticky_menu_click',
                        click_detail: offerItems[offerIndex].buttonText,
                    });
                }}
            >
                <div className="d-flex flex-wrap justify-content-center">{`Explore ${offerItems[offerIndex].buttonText}`}</div>
            </NavLink>
        </div>
    </div>
}

export default StickyLeftButton;
